import { createContext } from 'react';

import { SectionDisplayName } from '../config/index';

export interface SectionConfig {
  hide?: boolean;
  showMarketing?: boolean;
}

export interface ComfortConfig extends SectionConfig {
  hasZones?: boolean;
}

export interface AppConfig {
  meta?: {
    campusName?: string;
    currentSectionName?: SectionDisplayName;
    currentPageName?: string;
  };
  sections: {
    comfort: ComfortConfig;
    ev: SectionConfig;
    battery: SectionConfig;
  };
}

export interface AppContextValue {
  appConfig: AppConfig;
  setAppConfig: (config: AppConfig) => void;
}

export const defaultAppConfig: AppConfig = {
  sections: {
    comfort: {
      hasZones: true,
      showMarketing: false,
    },
    ev: {
      hide: false,
      showMarketing: false,
    },
    battery: {
      hide: false,
      showMarketing: false,
    },
  },
};

export const AppContext = createContext<AppContextValue>({
  appConfig: defaultAppConfig,
  setAppConfig: () => {},
});
